<ion-header>
  <ion-toolbar>
    <ion-back-button slot="start" (click)="back()" text=""></ion-back-button>
    <ion-title *ngIf="isNew">Neue Vorlage</ion-title>
    <ion-title *ngIf="!isNew">{{template?.description}}</ion-title>
    <ion-buttons slot="end" *ngIf="!isNew" (click)="deleteTemplate()">
      <ion-button>
        <ion-icon slot="icon-only" name="fa-trash"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>


<ion-content class="ion-padding">
  <h1 *ngIf="isNew">Neue Vorlage</h1>
  <h1 *ngIf="!isNew">{{template?.description}}</h1>

  <h2>Bezeichnung</h2>
  <input type="text" placeholder="Mustervorlage...." [(ngModel)]="template.description">

  <h2>Tätigkeiten</h2>
  <div id="search-sec">
    <div class="search" >
      <ion-icon name="fa-circle-check"></ion-icon>
      <input #search type="search" class="search-input" placeholder="neue Tätigkeit..." [(ngModel)]="newTaskDescription" (keyup.enter)="addTask()"/>
    </div>
    <div class="c-bttn" (click)="addTask()">
      <ion-icon name="fa-plus"></ion-icon>
    </div>
  </div>

  <ion-item *ngFor="let item of tasks">
    <ion-label>
      {{item.description}}
    </ion-label>
    <div slot="end">
      <div style="display: flex; align-items: center; padding: 10px 0;">
        <div class="arrows">
          <div class="c-bttn" style=" margin-bottom: 3px;" (click)="taskUp(item)">
            <ion-icon name="fa-angle-right" style="rotate: -90deg;"></ion-icon>
          </div>
          <div class="c-bttn" (click)="taskDown(item)">
            <ion-icon name="fa-angle-right" style="rotate: 90deg;"></ion-icon>
          </div>
        </div>
        <div class="c-bttn" (click)="deleteTask(item)">
          <ion-icon name="fa-x-mark"></ion-icon>
        </div>
      </div>
    </div>
  </ion-item>

</ion-content>


<ion-footer>
  <ion-toolbar class="ion-padding" style="padding-top: 0;">
    <div class="button main-button" (click)="save()">Speichern</div>
  </ion-toolbar>
</ion-footer>
